module.exports = __webpack_public_path__ + "static/media/VennToolbarActions.0080beb4.svg";